
import JobCard from './JobCard'

export default function JobsList({website}) {
    const deployJobs = ()=>{
        return website?.settings?.jobs?.map((job, inx)=>{
            return <JobCard key={`jobsList_inx_${inx}`} website={website} job={job}/>
        })
    }
    return (
        <div className='jobsList_dashboard'>
            {deployJobs()}
        </div>
    )
}
